import React from "react";
import VideoCard from "../videoCard/VideoCard";
import {Video} from "../../../../common/video/models/Video";
import styles from "./VideoList.module.css";

interface VideoListProps {
    videos: Video[];
    setMsg: (msg: string) => void;
}

export default function VideoList({videos, setMsg}: VideoListProps) {
    
    return (
        <div className={styles.list}>
            {videos.map((video) => (
                <VideoCard 
                    key={video.id} 
                    video={video} 
                    setMsg={setMsg} 
                />
            ))}
        </div>
    );
}
